/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilitiesGroupSubgroupSpec } from './capabilitiesGroupSubgroupSpec';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface CapabilityOrgTypeDeleteSpec { 
    /**
     * Org Type
     */
    org_type: string;
    service_type: ServiceTypeEnum;
    /**
     * If set to true, the API deletes all OrgType Capabilities.
     */
    delete_all?: boolean;
    capabilities?: Array<CapabilitiesGroupSubgroupSpec>;
}
export namespace CapabilityOrgTypeDeleteSpec {
}


